import { get, isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

import { NO_DATA_MESSAGE } from '../../utils/constants'
import { formatPercentOneDecimal } from '../../utils/functions'
import AsOfDate from '../AsOfDate'
import ScrollingTable from '../Tables/ScrollingTable'

class EtfCommodityIndexSectors extends PureComponent {
  constructor(props) {
    super(props)

    const etfCommodityIndexSectors = get(
      props.data,
      'etfCommodityIndexSectors',
      []
    )
    this.asOfDate = get(etfCommodityIndexSectors, '[0].calendarDate', '')

    this.columns = [
      {
        Header: 'Ticker',
        id: 'ticker',
        accessor: 'ticker',
      },
      {
        Header: 'Commodity Sector',
        id: 'sectorName',
        accessor: 'sectorName',
      },
      {
        Header: 'Commodity',
        id: 'commodityName',
        accessor: 'commodityName',
      },
      {
        Header: 'Facility',
        id: 'tradingFacility',
        accessor: 'tradingFacility',
      },
      {
        Header: 'Daily Weight (%)',
        id: 'weight',
        accessor: 'weight',
      },
    ]

    const tableData = []
    etfCommodityIndexSectors.forEach((sector) => {
      sector?.commodities?.forEach((commodity) => {
        tableData.push({
          sectorName: sector?.sectorName,
          commodityName: commodity?.commodityName,
          tradingFacility: commodity?.tradingFacility,
          ticker: commodity?.ticker,
          weight: formatPercentOneDecimal(commodity?.weight),
        })
      })
    })

    this.tableData = tableData
    this.scrollingTableOptions = {
      stripedTable: true,
    }
  }

  render() {
    if (isEmpty(this.tableData)) {
      return <p>{NO_DATA_MESSAGE}</p>
    }

    return (
      <>
        <AsOfDate date={this.asOfDate} />
        <ScrollingTable
          columns={this.columns}
          data={this.tableData}
          options={this.scrollingTableOptions}
        />
      </>
    )
  }
}

EtfCommodityIndexSectors.propTypes = {
  data: PropTypes.shape({
    etfCommodityIndexSectors: PropTypes.array,
  }),
}

export default EtfCommodityIndexSectors
